import { MESES, fmt } from "../constants";

export default function FluxoCaixa({ fluxo, mes, setMes, ano, setAno }) {
  if (!fluxo) return null;
  return (
    <div style={{background:"#fff",borderRadius:8,padding:"12px 16px",marginBottom:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",display:"flex",gap:16,alignItems:"center",flexWrap:"wrap"}}>
      <span className="fs-13">Fluxo de caixa:</span>
      <select style={{padding:"3px 8px",fontSize:12,border:"1px solid var(--z-border)",borderRadius:4}} value={mes} onChange={e=>setMes(parseInt(e.target.value))}>
        {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
      </select>
      <input type="number" style={{width:70,padding:"3px 8px",fontSize:12,border:"1px solid var(--z-border)",borderRadius:4}} value={ano} onChange={e=>setAno(parseInt(e.target.value))}/>
      <span className="fs-13">Entradas: <strong className="text-success">R$ {fmt(fluxo.entradas)}</strong></span>
      <span className="fs-13">Saidas: <strong className="text-danger">R$ {fmt(fluxo.saidas)}</strong></span>
      <span style={{fontSize:14,fontWeight:700,color:fluxo.saldo>=0?"var(--z-success-text)":"var(--z-danger-text)"}}>Saldo: R$ {fmt(fluxo.saldo)}</span>
    </div>
  );
}
